import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'pending-orders-bottom-sheet',
  templateUrl: './pending-orders-bottom-sheet.component.html',
  styleUrl: './pending-orders-bottom-sheet.component.css'
})
export class PendingOrdersBottomSheetComponent {

  constructor(
    private bottomSheetRef: MatBottomSheetRef<PendingOrdersBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any
  ) { }

  proceed() {
    this.bottomSheetRef.dismiss(true);
  }

  cancel() {
    this.bottomSheetRef.dismiss(false);
  }

}
